import { jwtDecode } from 'jwt-decode';
//? Só a sessão salva no navegador (template). As chamadas HTTP saíram na migração Orval (sub-spec 10): todo
//? transporte é o src/api/mutator.ts — este arquivo não configura mais o axios global.

const AUTH_SESSION_KEY = 'hyper_user';

const getUserFromSession = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};
class APICore {
  isUserAuthenticated = () => {
    const user = this.getLoggedInUser();

    const token = user?.token || user?.tokenData?.accessToken;

    if (!user || !token) {
      return false;
    }
    try {
      const decoded: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        console.warn('access token expired');
        return false;
      }
      return true;
    } catch (error) {
      console.warn('failed to decode token for authentication check', error);
      return false;
    }
  };

  setLoggedInUser = (session: any) => {
    if (session)
      sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
    else {
      sessionStorage.removeItem(AUTH_SESSION_KEY);
    }
  };
  /**
   * Returns the logged in user
   */
  getLoggedInUser = () => {
    return getUserFromSession();
  };

  setUserInSession = (modifiedUser: any) => {
    let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
    if (userInfo) {
      const { token, user } = JSON.parse(userInfo);
      this.setLoggedInUser({ token, ...user, ...modifiedUser });
    }
  };
}

export const getCurrentTxclmtId = (): number | null => {
    const raw = sessionStorage.getItem('hyper_user');

    if (!raw) {
        console.warn('[DEBUG] Nenhum usuário na sessão');
        return null;
    }
    
    try {
        const parsed = JSON.parse(raw);
        const txclmtId = parsed?.txclmtId ?? null;
        return txclmtId;
    } catch (error) {
        console.error('[DEBUG] Erro ao parsear sessionStorage:', error);
        return null;
    }
};

export { APICore };
